<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    {{ node.IconName }}
                </mat-icon>
                <span>
                    {{ node.DisplayText }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                {{ node.Description }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
            </form>
            <mat-list *ngIf="node && node.Nodes.length > 0" role="list">
                <mat-list-item role="listitem" *ngFor="let n of node.Nodes; let i = index">
                    <button mat-button (click)="appService.navigateTo(n.route, n.venueRootSubdomain)">
                        <mat-icon class="material-symbols-outlined">
                            {{ n.IconName }}
                        </mat-icon>
                        <span class="button-text">
                            {{ n.DisplayText }}
                        </span>
                    </button>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
        <mat-card-footer class="login-footer">
        </mat-card-footer>
    </mat-card>
</div>

